// extracted by mini-css-extract-plugin
export default {"link-container":"styles_link-container__2cXG1","link":"styles_link__3ZC-Z","active":"styles_active__ZRzJc"};